import { useState } from 'react';
import { sendEmail } from '../../Services/emailService';

const useSendEmail = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendEmailHandler = async (emailData: any) => {
    setLoading(true);
    try {
      await sendEmail(emailData);
      setLoading(false);
      setError(null);
    } catch (err) {
      setLoading(false);
      setError('Failed to send email');
    }
  };

  return { sendEmailHandler, loading, error };
};

export default useSendEmail;
